import { AppointmentControllerApi, InstantAppointment } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useCreateInstantAppointment = () =>
  useMutationWithLoading(
    async (params: InstantAppointment & { xTENANTID?: string }) =>
      new AppointmentControllerApi(getConfigObject()).createInstantAppointment(
        params,
        params.xTENANTID
      )
  );
